<template>
  <div class="preview">
    <div class="preview__inner-1" @click="onClick">
      <div class="preview__inner-2" :style="{padding: styles.previewPadding}">
      </div>
    </div>
    <div v-if="!styles.showEditor" class="preview__corner">
      <button class="preview__button button" @click="toggleEditor(true)" v-title="'Edit file'">
        <icon-pen></icon-pen>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import store from '../store';
import localDbSvc from '../services/localDbSvc';

const appUri = `${window.location.protocol}//${window.location.host}`;

export default {
  computed: {
    ...mapGetters('layout', [
      'styles',
    ]),
  },
  methods: {
    ...mapActions('data', [
      'toggleEditor',
    ]),
    async onClick(evt) {
      let elt = evt.target;
      while (elt && elt !== this.$el) {
        // Handle wikilink clicks
        if (elt.classList && elt.classList.contains('wikilink')) {
          evt.preventDefault();
          evt.stopPropagation();
          const linkName = elt.dataset ? elt.dataset.wikilink : elt.getAttribute('data-wikilink');
          if (linkName) {
            await this.navigateToNote(linkName);
          }
          return;
        }
        // Handle external links
        if (elt.href && elt.href.match(/^https?:\/\//)
          && (!elt.hash || elt.href.slice(0, appUri.length) !== appUri)) {
          evt.preventDefault();
          const wnd = window.open(elt.href, '_blank');
          wnd.focus();
          return;
        }
        elt = elt.parentNode;
      }
    },
    async navigateToNote(linkName) {
      const files = store.getters['file/items'].filter(
        file => file.type === 'file' && file.parentId !== 'trash'
      );
      const linkedFile = files.find(
        f => f.name.toLowerCase() === linkName.toLowerCase()
      );
      if (linkedFile) {
        await localDbSvc.loadItem(`${linkedFile.id}/content`);
        store.commit('file/setCurrentId', linkedFile.id);
      } else {
        store.dispatch('notification/info', `Note "${linkName}" not found.`);
      }
    },
  },
};
</script>

<style lang="scss">
@import '../styles/variables.scss';

.preview,
.preview__inner-1 {
  position: absolute;
  width: 100%;
  height: 100%;
}

.preview__inner-1 {
  overflow: auto;
}

.preview__inner-2 {
  margin: 0;
}

.preview__inner-2 > :first-child > :first-child {
  margin-top: 0;
}

$corner-size: 110px;

.preview__corner {
  position: absolute;
  top: 0;
  right: 0;

  &::before {
    content: '';
    position: absolute;
    right: 0;
    border-top: $corner-size solid rgba(0, 0, 0, 0.075);
    border-left: $corner-size solid transparent;
    pointer-events: none;

    .app--dark & {
      border-top-color: rgba(255, 255, 255, 0.075);
    }
  }
}

.preview__button {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 40px;
  height: 40px;
  padding: 5px;
  color: rgba(0, 0, 0, 0.25);

  .app--dark & {
    color: rgba(255, 255, 255, 0.25);
  }

  &:active,
  &:focus,
  &:hover {
    color: rgba(0, 0, 0, 0.33);
    background-color: transparent;

    .app--dark & {
      color: rgba(255, 255, 255, 0.33);
    }
  }
}
</style>
